import { toRem, toRems } from "../../../../helpers/theme";

const style = ({ theme }) => ({
    position: "absolute",
    bottom: 0,
    left: 0,
    zIndex: theme.zIndex.over,
    width: "100%",
    [theme.breakpoints.up("md")]: {
        bottom: toRem(60),
        padding: toRems([0, 40]),
    },
});

export default style;
